import log from 'loglevel';
import { ListService } from '@/service/list/ListService';
import { BoughtList } from '@/API';
import { BoughtListRepository } from '@/repository/list/impl/BoughtListRepository';
import { GraphQLOptionsV6 } from '@aws-amplify/api-graphql';
import { PagedList } from '@/repository/GenericRepository.ts';

/**
 * Service for fetching bought lists with pagination, filtering, and sorting.
 */
export class BoughtListService extends ListService<BoughtList> {
  /**
   * Updates the opt-out status of a bought list item using secure backend mutation.
   *
   * @param id - The ID of the bought list item.
   * @param value - The new opt-out value.
   * @returns The updated bought list item.
   * @throws Error Will throw an error if the mutation fails.
   */
  async optOut(id: string, value: boolean) {
    try {
      return await (this.repository as BoughtListRepository).optOut(id, value);
    } catch (error) {
      log.error('Error updating opt out:', error);
      throw error;
    }
  }

  async searchProspects(
    queryVariables: GraphQLOptionsV6['variables']
  ): Promise<PagedList<BoughtList, unknown>> {
    return await (this.repository as BoughtListRepository).searchProspects(
      queryVariables
    );
  }
}
